<template>
    <div>
        <layout-one>
          <el-form :model="form" label-width="100px" :inline="true" ref="form" :rules="rules">
            <div class="section large-ele-input__">
              <h4>基本信息</h4>
              <div class="sectionBox">
                  <el-form-item label="考点名称" prop="name">
                      <el-input placeholder="请输入" v-model="form.name"></el-input>
                  </el-form-item>
              </div>
              <div class="sectionBox">
                  <el-form-item label="启用状态" :required="true">
                      <el-radio-group v-model="form.state">
                          <el-radio-button label=1>启用</el-radio-button>
                          <el-radio-button label=0>停用</el-radio-button>
                      </el-radio-group>
                  </el-form-item>
              </div>
              <div class="sectionBox">
                  <el-form-item label="联系人">
                      <el-input placeholder="请输入" v-model="form.contact"></el-input>
                  </el-form-item>
              </div>
              <div class="sectionBox">
                  <el-form-item label="联系人电话">
                      <el-input placeholder="请输入" v-model="form.phone"></el-input>
                  </el-form-item>
              </div>
            </div>
            <div class="section mt20">
              <h4>关联函授站</h4>
              <div class="sectionBox">
                  <el-form-item label="请选择">
                      <div class="stationBox">
                        <div class="stationTop">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                            <div class="searchCourse ml30">
                                <el-input  placeholder="快捷搜索" v-model="stationStr"></el-input>
                                <div class="searchPos">
                                    <i class="iconfont icon-sousuo"></i>
                                </div>
                            </div>
                        </div>
                        <div class="station-container">
                          <el-checkbox-group v-model="form.form_stationIds" @change="handleCheckedCitiesChange">
                            <el-checkbox v-for="station in stationSelectData" :label="station.id" :key="station.id" :title="station.name">{{station.name}}</el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>
                  </el-form-item>
              </div>
            </div>
            <div class="section mt20">
              <h4>地址信息</h4>
              <div class="sectionBox small-ele-input__">
                  <el-form-item label="所属区域">
                      <el-select v-model="form.province" placeholder="请选择省" @change="changeProvince()">
                        <el-option
                          v-for="item in provinceData"
                          :key="item.code"
                          :label="item.name"
                          :value="item.name">
                        </el-option>
                      </el-select>
                      <el-select v-model="form.city" placeholder="请选择" class="ml20" @change="changeProvince()">
                        <el-option
                          v-for="item in cityData"
                          :key="item.code"
                          :label="item.name"
                          :value="item.name">
                        </el-option>
                      </el-select>
                      <el-select v-model="form.county" placeholder="请选择" class="ml20" @change="changeProvince()">
                        <el-option
                          v-for="item in countyData"
                          :key="item.code"
                          :label="item.name"
                          :value="item.name">
                        </el-option>
                      </el-select>
                  </el-form-item>
              </div>
              <div class="sectionBox">
                  <el-form-item label="详细地址" prop="address">
                      <!-- <el-input class="lang" placeholder="请输入" v-model="form.address" @input="search"></el-input> -->
                      <el-select v-model="form.address" placeholder="请选择" class="addRess" filterable allow-create clearable remote :remote-method="search">
                        <el-option
                          v-for="item in addressList"
                          :key="item.id"
                          :label="item.address + '：' + item.title"
                          :value="item.address + item.title">
                        </el-option>
                      </el-select>
                  </el-form-item>
              </div>
              <div class="sectionBox">
                <el-form-item label="坐标">
                  <el-input class="lang"  v-model="form.site"></el-input>
                </el-form-item>
              </div>
              <div id="mapContainer">
              </div>
            </div>
          </el-form>
        </layout-one>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { AllStation } from '@/http/modules/baseSet/station'
import { addPlaceFn, getSinglePlace, updatePlaceFn } from '@/http/modules/baseSet/examSite'
import dynamicLoadScript from '@/help/dynamicLoadScript'
var cityData = require('./citys.json')
export default {
  name: 'addSite',
  data () {
    return {
      saveMethods: 'addOrEdit',
      backMethods: 'cancelPage',
      isEdit: false,
      checkAll: false,
      isIndeterminate: true,
      checkedCities: [],
      stationStr: '',
      stationData: [],
      provinceData: cityData,
      cityData: cityData[0].cityList,
      countyData: cityData[0].cityList[0].areaList,
      form: {
        name: '',
        state: 1,
        contact: '',
        phone: '',
        province: '',
        city: '',
        county: '',
        address: '',
        site: '',
        form_stationIds: []
      },
      // Student management
      rules: {
        name: [
          {required: true, message: '请填写考点名称', trigger: 'blur'},
        ],
        contact: [
          {required: true, message: '请填写联系人', trigger: 'blur'},
        ],
        address: [
          {required: true, message: '请填写考点地址', trigger: 'blur'},
        ]
      },
      // map 地图相关参数
      value: "", // 搜索内容
      addressList: [], // 搜索结果
      selectValue: [], // 选择的某个结果
      timeout: null, // 搜索定时器
      /* ** map 坐标 ** */
      latitude: "39.908823",
      longitude: "116.39747",
      markerLayer: '',
      /*  */
      isCanSetAddress: false,
    }
  },
  computed: {
      stationSelectData () {
        if (this.stationStr) {
            return this.stationData.filter(item => item.name.indexOf(this.stationStr) > -1)
        }
        return this.stationData
      }
  },
  watch: {
    'form.province' (val, oldVal) {
      if (!(this.$route.query.id && !this.isCanSetAddress)) {
        this.form.address = this.form.province + this.form.city + this.form.county;
      }
      this.cityData = this.provinceData.filter(item  => item.name == val)[0] ? this.provinceData.filter(item  => item.name == val)[0].cityList : []
      if (this.cityData.length) {
        if (this.form.city && this.cityData.map(item => item.name).includes(this.form.city)) {
          this.countyData = this.cityData.filter(item  => item.name == val)[0] ? this.cityData.filter(item  => item.name == val)[0].areaList : []
        } else {
          this.form.city = this.cityData[0].name
        }
      }
    },
    'form.city' (val) {
      if (!(this.$route.query.id && !this.isCanSetAddress)) {
        this.form.address = this.form.province + this.form.city + this.form.county;
      }
      this.countyData = this.cityData.filter(item  => item.name == val)[0] ? this.cityData.filter(item  => item.name == val)[0].areaList : [];
      if (this.countyData.length) {
        if (this.form.county && this.countyData.map(item => item.name).includes(this.form.county)) {
        } else {
          this.form.county = this.countyData[0].name
        }
      }
    },
    'form.county' (val) {
      if (!(this.$route.query.id && !this.isCanSetAddress)) {
        this.form.address = this.form.province + this.form.city + this.form.county;
      }
    },
    'form.address' (val) {
      this.search(val);
    },
    'form.site' (val) {
      let latlng = val.split(',');
      if (this.map) {
        this.map.setCenter(new TMap.LatLng(latlng[0], latlng[1]))
        if (this.markerLayer) {
          this.markerLayer.setMap(null);
          this.markerLayer = null;
        }
        this.markerLayer = new TMap.MultiMarker({
            map: this.map,
            styles: {
              "marker": new TMap.MarkerStyle({
                  "width": 25,
                  "height": 35,
                  "anchor": { x: 16, y: 32 },
              })
            },
            geometries: [{
                "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                "styleId": 'marker',  //指定样式id
                "position": new TMap.LatLng(latlng[0], latlng[1]),  //点标记坐标位置
              }
            ]
        })
      }
    }
  },
  created () {
    this.initStatus();
    this.initStationData();
  },
  mounted () {
    this.SAVE_PAGE_THIS(this);
    this.loadMapJs();
  },
  methods: {
    changeProvince(){
      this.isCanSetAddress = true;
    },

    loadMapJs () {
        const MAPURL = 'https://map.qq.com/api/gljs?v=1.exp&key=GHFBZ-7JWC5-5WWIQ-QSCUF-QAT5O-XRFKM'
        dynamicLoadScript(MAPURL, (err) => { 
            if (err) {//若脚本加载错误，这弹出错误提示
              this.$message.error(err.message)
              return
            }
            this.initMap()//否则执行初始化map方法
        })
    },

    ...mapMutations(['SAVE_PAGE_THIS']),

    async addOrEdit () {
      this.$refs['form'].validate(async (valid) => {
          if (valid) {
              let params = {...this.form}
              params.stationIds = params.form_stationIds.join()
              for (let key in params) {
                if (key.startsWith('form_')) {
                  delete params[key]
                }
              }
              const dealFn = this.isEdit ? updatePlaceFn : addPlaceFn
              const { code } = await dealFn(params)
              if (code ==  1) {
                this.$otsPopPro({
                    content: this.isEdit ? '修改成功' : '添加成功',
                    cancelName: '返回',
                    okName: this.isEdit ? '查看' : '去添加教室'
                }).then(() => {
                  if (!this.isEdit) {
                      this.$router.push({
                        name: 'classroom'
                      })
                  } else {
                    this.goIndex()
                  }
                }).catch(() => {
                    this.goIndex()
                })
              }
          } else {
              return false;
          }
      })
    },


    cancelPage () {
      this.$router.go(-1)
    },


    goIndex () {
        this.$router.push({
            name: 'examSite'
        })
    },
    
    async initStatus () {
      if (this.$route.query.id) {
        this.isEdit = true
        let id = this.$route.query.id
        const { data } = await getSinglePlace({id: id})
        for (let item in this.form) {
          this.form[item] = data.hasOwnProperty(item) ? data[item] : this.form[item]
        }
        this.form.id = data.id
        this.form.form_stationIds = data.stationMap.map(item => item.id)
      } else {
        this.initSelect()
      }
    },

    async initStationData () {
      const { data } = await AllStation()
      this.stationData = data
    },

    initSelect () {
      this.form.province = this.provinceData[0].name;
      this.form.city = this.cityData[0].name;
      this.form.county = this.countyData[0].name;
      this.form.address = this.form.province + this.form.city + this.form.county;
    },

    handleProvince (obj) {
      this.cityData = obj.cityList
    },

    /*********************************
     * @this (initMap)初始化地图
     *********************************/
    initMap() {
        // (1) 标记 this
        let that = this;
        // (2) 中心点
        var center = new TMap.LatLng(this.latitude, this.longitude);
        // (3) 创建地图实例
        this.map = new TMap.Map(document.getElementById('mapContainer'), {
          center: center, // 中心点
          zoom: 17, // 地图缩放级别
          pitch: 43.5, // 设置俯仰角度
          rotation: 0, // 地图旋转角度
          viewMode: '2D', // 2D | 3D
        });
        // (4) 填充物 (初始标记)
        that.markerLayer = new TMap.MultiMarker({
          map: that.map,
          styles: {
            "marker": new TMap.MarkerStyle({
                "width": 25,
                "height": 35,
                "anchor": { x: 16, y: 32 },
            })
          },
          geometries: [{
              "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              "styleId": 'marker',  //指定样式id
              "position": center,  //点标记坐标位置
            }
          ]
        })

        // (5) 地图点击事件
        this.map.on("click",function(evt){
            // (5.1) 点击处坐标
            var lat = evt.latLng.getLat().toFixed(8);
            var lng = evt.latLng.getLng().toFixed(8);
            // (5.2) 赋值表单坐标
            that.form.site = lat + "," + lng;
            // (5.3) 删除上一个坐标点, 只保留一个
            if (that.markerLayer) {
              that.markerLayer.setMap(null);
              that.markerLayer = null;
            }
            // (5.4) 点击创建新的填充物
            that.markerLayer = new TMap.MultiMarker({
              map: that.map,
              styles: {
                "marker": new TMap.MarkerStyle({
                    "width": 25,
                    "height": 35,
                    "anchor": { x: 16, y: 32 },
                })
              },
              geometries: [{
                  "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                  "styleId": 'marker',  //指定样式id
                  "position": new TMap.LatLng(evt.latLng.getLat(), evt.latLng.getLng()),  //点标记坐标位置
                }
              ]
            })
        })
    },

    /*********************************
     * @this (search)搜索地图地址
     * key: "UCWBZ-Z53C5-YKTIT-Q5YGW-GKHOJ-SCFYH"
     * key: "GHFBZ-7JWC5-5WWIQ-QSCUF-QAT5O-XRFKM"
     *********************************/
    search(value){
      // (1) 下拉列表重置
      this.addressList = [];
      // (2) 调用腾讯地图地址API查询接口
      if (value) {
        let that = this;
        this.timeout = setTimeout( () => {
          that.$jsonp("https://apis.map.qq.com/ws/place/v1/suggestion/", {
            key: "GHFBZ-7JWC5-5WWIQ-QSCUF-QAT5O-XRFKM",
            output: "jsonp",
            page_size: 20,
            keyword: value,
          }).then( (res) => {
            if (res.data.length == 0) {
              this.$message.warning('当前地址无法定位，请输入正确地址或手动于地图点击标注！')
            }           
            this.addressList = res.data;
            this.latitude = res.data[0].location.lat;
            this.longitude = res.data[0].location.lng;
            this.form.site = this.latitude + ',' + this.longitude;
          })
        }, 100)
      }
    },

    handleCheckAllChange(val) {
      let allData = this.stationSelectData.map(item => item.id)
      this.form.form_stationIds = val ? allData : [];
      this.isIndeterminate = false;
    },

    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.stationSelectData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.stationSelectData.length;
    }

  },

  beforeDestroy () {
    if (this.map) {
      this.map.destroy()
    }
  },


}
</script>
<style lang="less" scoped>
/deep/ .el-select.addRess{
  .el-input {
    width: 500px;
    input {
      width: 500px;
    }
  }
}

#mapContainer {
    /*地图(容器)显示大小*/
    width:1200px;
    height:400px;
    margin-bottom: 30px;
    margin-left: 100px;
}
.section {
  border-bottom: 1px solid #F1F2F5;
  h4{
    margin-bottom: 30px;
  }
  .sectionBox {
      .lang {
        width: 512px;
      }
  }
  .stationBox {
      width: 1000px;
      max-height: 300px;
      background-color: #F8F9FC;
      overflow-y: auto;
      padding: 20px;
      border-radius: 8px;
      .stationTop {
        display: flex;
        margin-bottom: 20px;
      }
      .searchCourse {
          position: relative;
          .searchPos {
              width: 40px;
              height: 18px;
              line-height: 18px;
              border-left: 1px solid #E1E6ED;
              position: absolute;
              right: 0;
              top: 11px;
              color: #C2C6CC;
              font-size: 14px;
              i {
                  margin-left: 10px;
                  cursor: pointer;
              }
          }
      }
  }
  /deep/ .el-form-item {
      margin-bottom: 30px!important;
  }
  /deep/ .el-radio-button__inner {
      margin-right: 16px;
      color: #45494D!important;
      background: #F4F5F8!important;
      font-size: 13px;
      border-radius: 4px!important;
      border: 1px solid #DADDE6!important;
      width: 64px;
      height: 32px;
      line-height: 32px;
      padding: 0;
  }
  /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
      background: #EBF5FF!important;
      border: 1px solid #006AFF!important;
      color: #006AFF!important;
      box-shadow:none;
  }
  .station-container /deep/ .el-checkbox {
    width: 300px;
    overflow: hidden;
    white-space: nowrap;
  }
}

</style>
